import { useEffect, useState } from 'react'
import { setToken } from '../auth'

interface Props { onAuthed: () => void }

const API_BASE = (import.meta.env.VITE_API_BASE as string) ?? ''

export default function LoginGate({ onAuthed }: Props) {
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const [showAdvanced, setShowAdvanced] = useState(false)
  const [bearer, setBearer] = useState('')

  // If we land back from a magic-link verify, the URL fragment has #session=...
  useEffect(() => {
    const hash = window.location.hash || ''
    const m = hash.match(/(?:^#|&)session=([a-f0-9]+)/i)
    if (m && m[1]) {
      setToken(m[1])
      // Wipe the fragment from the address bar
      history.replaceState(null, '', window.location.pathname + window.location.search)
      onAuthed()
    }
  }, [onAuthed])

  async function sendLink() {
    setBusy(true); setErr(null)
    try {
      const res = await fetch(`${API_BASE}/auth/magic/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      })
      const j = await res.json().catch(() => ({})) as { ok?: boolean; error?: string }
      if (j.ok) setSent(true)
      else setErr(j.error ?? 'send failed')
    } catch (e) {
      setErr(String(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-gate" style={{ maxWidth: 380, margin: '15vh auto', textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 12 }}>Jamie Dashboard</h1>

      {!sent ? (
        <>
          <p className="secondary" style={{ marginBottom: 20 }}>
            Sign in with a one-shot link to your inbox.
          </p>
          <button
            type="button"
            onClick={sendLink}
            disabled={busy}
            style={{
              minHeight: 44, padding: '0 20px',
              background: 'linear-gradient(135deg, var(--accent) 0%, #b5f5ff 100%)',
              color: '#031019', fontWeight: 600, border: '1px solid rgba(255,255,255,0.45)',
              borderRadius: 999, fontSize: '0.9rem', letterSpacing: '0.02em',
              cursor: busy ? 'wait' : 'pointer',
            }}>
            {busy ? 'sending…' : 'Email me a sign-in link'}
          </button>
          {err && (
            <div style={{ marginTop: 14, color: 'var(--critical)', fontSize: '0.78rem' }}>
              {err}
            </div>
          )}
        </>
      ) : (
        <>
          <p className="secondary" style={{ marginBottom: 8 }}>
            Check your inbox.
          </p>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.78rem' }}>
            Click the link to sign in. Expires in 10 min.
          </p>
          <button type="button" onClick={() => { setSent(false); setErr(null) }}
            style={{ marginTop: 16, fontSize: '0.7rem' }}>
            re-send
          </button>
        </>
      )}

      <div style={{ marginTop: 32, paddingTop: 16, borderTop: '1px solid var(--border-soft)' }}>
        {!showAdvanced ? (
          <button type="button" onClick={() => setShowAdvanced(true)}
            style={{ fontSize: '0.65rem', color: 'var(--text-muted)',
                     background: 'transparent', border: 'none', cursor: 'pointer' }}>
            advanced: paste bearer token
          </button>
        ) : (
          <form onSubmit={e => {
            e.preventDefault()
            const t = bearer.trim()
            if (!t) return
            setToken(t)
            onAuthed()
          }} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <input
              type="text"
              value={bearer}
              onChange={e => setBearer(e.target.value)}
              placeholder="bearer token"
              autoComplete="off"
              spellCheck={false}
              style={{ fontSize: '0.78rem' }}
            />
            <button type="submit">continue</button>
          </form>
        )}
      </div>
    </div>
  )
}
